

import React from 'react';
import { AddonsConsumer } from '../../../../Addons';
import SupersizeMyEditAddonViewComponent from '../components/SupersizeMyEditAddonView';

function SupersizeMyEditAddonView(props) {
  return (
    <AddonsConsumer>
      {({
        actions: { getSupersizeMyEdits }
      }) =>
      <SupersizeMyEditAddonViewComponent
        getSupersizeMyEdits={getSupersizeMyEdits}
        {...props} />}


    </AddonsConsumer>);

}

export default SupersizeMyEditAddonView;